<template>
  <div v-if="tribe.id" class="ma-5 black--text">
    <!-- <AppBar :tribe="tribe" /> -->
    <div :class="!$isMobile ? 'mx-2':''">
      <img v-if="avatarImage" :src="hackURL(avatarImage)" class="logo" />
      <h1>
        {{ tribe.preferredName }}
      </h1>
      <h2>Registration form</h2>
    </div>
    <br />

    <RegistrationForm
      ref="form"
      :tribe="tribe"
      :questions.sync="answers"
      @change="updateFormChanges"
      :valid.sync="valid"
      :submitted="submitted"
    />

    <v-row>
      <v-col cols="12" md="auto">
        <v-btn
          @click="submit"
          large
          color="#2b707d"
          light
          :style="customBtnStyle"
        >
          Submit
        </v-btn>
      </v-col>
      <v-col v-if="!valid" cols="12" md="auto" class="caption error--text text-center pt-md-2">
        <p :class="mobile ? '' : 'pt-4 pl-4'">
          Please complete all required fields.
        </p>
      </v-col>
    </v-row>

    <Snackbar
      v-if="snackbar"
      :show="snackbar"
      :message="snackbarMsg"
      @clearSnackbar="clearSnackbar"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { isEmpty } from 'lodash'

import Snackbar from '@/components/Snackbar'
import RegistrationForm from '@/components/RegistrationForm'

import { getCustomFields, getDefaultFields, getInitialCustomFieldChanges } from '@/lib/custom-field-helpers.js'
import { parseInterval } from '@/lib/date-helpers.js'
import { ignoreList } from '@/lib/form-helpers.js'

const hackURL = require('@/lib/hack-url.js')

function notIgnored (field) {
  return !ignoreList.has(field.label)
}

export default {
  name: 'RegistrationNew',
  components: {
    Snackbar,
    RegistrationForm
  },
  data: () => ({
    loading: true,

    tribe: {},

    formData: {},
    answers: [],

    snackbar: false,
    snackbarMsg: null,
    valid: false,
    submitted: false
  }),
  apollo: {
    tribe: {
      query: gql` query ($tribeId: String!) {
        tribe(id: $tribeId) {
          public {
            preferredName
            avatarImage { uri }
            headerImage { uri }
            joiningQuestions {
              label
              type
            }
            customFields {
              key
              type

              label
              required
              visibleBy
              order
              
              tombstone {
                date
              }

              ... on CommunityCustomFieldList {
                multiple
                options
              }
              
            }
          }
        }
      }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          tribeId: this.$route.params.tribeId || ''
        }
      },
      update (data) {
        const tribe = data.tribe.public[0]
        // const tribe = wphData // from fixtures

        if (tribe.joiningQuestions) {
          this.answers = tribe.joiningQuestions.map(q => {
            return {
              label: q.label,
              value: ''
            }
          })
        }
        return {
          id: this.$route.params.tribeId,
          ...tribe
        }
      }
    }
  },
  computed: {
    mobile () {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
    },
    customBtnStyle () {
      return this.mobile ? { width: '100%' } : null
    },
    defaultFields () {
      if (isEmpty(this.tribe)) return []
      const fields = getDefaultFields(this.tribe.customFields.filter(notIgnored))

      return fields
    },
    customFields () {
      if (isEmpty(this.tribe)) return []
      return getCustomFields(this.tribe.customFields.filter(notIgnored))
    },
    avatarImage () {
      return this.tribe.avatarImage ? this.tribe.avatarImage.uri : null
    },
    submission () {
      const submission = {}
      Object.entries(this.formData).forEach(([key, value]) => {
        if (!isEmpty(this.formData[key])) {
          switch (key) {
            case 'birthOrder':
              submission[key] = parseInt(value)
              break
            case 'altNames':
              if (!isEmpty(this.formData.altNames)) {
                submission.altNames = { add: this.formData.altNames }
              }
              break
            case 'dateOfBirth':
              submission.aliveInterval = `${this.formData.dateOfBirth}/`
              break
            case 'aliveInterval':
              submission.aliveInternal = parseInterval(this.formData.aliveInterval)
              break
            case 'customFields':
              const customFields = getInitialCustomFieldChanges(this.formData.customFields, this.tribe.customFields) // eslint-disable-line
              if (isEmpty(customFields)) break
              submission.customFields = customFields
              break
            default:
              submission[key] = value
          }
        } else if (key === 'deceased') {
          submission[key] = value
        }
      })

      return submission
    }
  },
  methods: {
    async updateFormChanges ($event) {
      this.formData = $event
    },
    hackURL,
    async submit () {
      this.submitted = true
      this.$refs.form.validate()

      if (!this.valid) return

      const res = await this.$apollo.mutate({
        mutation: gql`mutation (
          $groupId: String!
          $input: PersonProfileInput!
          $joiningQuestions: [SubmissionJoiningQuestionInput]
          $source: SubmissionSource
        ) {
          proposeNewGroupPerson(
            groupId: $groupId
            input: $input
            joiningQuestions: $joiningQuestions
            source: $source
          )
        }`,
        variables: {
          groupId: this.$route.params.tribeId,
          input: {
            ...this.submission,
            source: 'webForm'
          },
          joiningQuestions: this.answers,
          source: 'webForm'
        }
      })
        .catch(err => {
          console.error(err)
          this.showSnackbar('something went wrong. please contact the administration if you continue to have issues')
        })
      if (res) {
        // If success ... Do something?
        console.log(res)
        this.goToSuccessPage()
      }
    },
    goToSuccessPage () {
      this.$router.push({
        name: 'registrationSuccess',
        params: {
          tribe: this.tribe,
          input: this.submission
        }
      })
    },
    showSnackbar (msg) {
      this.snackbarMsg = msg
      this.snackbar = true
    },
    clearSnackbar () {
      this.snackbarMsg = ''
      this.snackbar = false
    }
  }
}
</script>

<style scoped lang="scss">
.logo {
  max-height: 400px;
  max-width: 90vw;
}
.wrapper {
  // background-color: white;
  width: 100%;
  height: 100%;
  max-width: 1000px;
  margin: 0 auto;
}
h1 {
  font-size: 1.5em;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 5px;
}
h2 {
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 4px;
}
.avatarImage {
  height: 100px;
  padding: 0 25px;
}

</style>
